import { authServerInstance, gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const getBehalfOf = async ({
  searchText = "",
  customer = "",
  shipper = "",
}) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/costomerUser/customerUser_fun`,
      {
        usrUsername: searchText,
        customer,
        shipper,
      },
    );

    return response.data.map((item) => ({
      ...item,
      key: item.usrId,
      title: item.usrUsername,
      value: item.usrId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const getUserById = async (id) => {
  try {
    const response = await authServerInstance.get(`/user-customer/user/${id}`);
    console.log(`response`);
    console.log(response.data);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getUsernameById = async (id) => {
  try {
    if (id != null && id !== "") {
      const response = await authServerInstance.get(
        `/user-customer/user/${id}`,
      );
      console.log(`response`);
      console.log(response);
      return response.data.username;
    }
  } catch (e) {
    console.error(e);
  }
};
